// extracted by mini-css-extract-plugin
export const container = "ExcursionActivityLevel-module--container--1avB7";
export const icons = "ExcursionActivityLevel-module--icons--2k7vq";
export const icon = "ExcursionActivityLevel-module--icon--1RQZw";
export const title = "ExcursionActivityLevel-module--title--3my5i";